export class GdsgBucketStats {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "bucketName",
            "baseName": "bucketName",
            "type": "string",
            "format": ""
        },
        {
            "name": "points",
            "baseName": "points",
            "type": "Array<GdsgRegionStatsPoint>",
            "format": ""
        },
        {
            "name": "totalStorageBytes",
            "baseName": "totalStorageBytes",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "membersProcessedTotal",
            "baseName": "membersProcessedTotal",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "failuresTotal",
            "baseName": "failuresTotal",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "dataLossTotal",
            "baseName": "dataLossTotal",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "putAckToBackupLagP95MsMax",
            "baseName": "putAckToBackupLagP95MsMax",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "sampleError",
            "baseName": "sampleError",
            "type": "string",
            "format": ""
        },
        {
            "name": "warnings",
            "baseName": "warnings",
            "type": "Array<GdsgOperationalWarning>",
            "format": ""
        },
        {
            "name": "dataLossSampleError",
            "baseName": "dataLossSampleError",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return GdsgBucketStats.attributeTypeMap;
    }
    constructor() {
    }
}
